import { temporarilyNotSupport } from '../../utils'

// 内存
export const onMemoryWarning = /* @__PURE__ */ temporarilyNotSupport('onMemoryWarning')
export const offMemoryWarning = /* @__PURE__ */ temporarilyNotSupport('offMemoryWarning')
